
// import Home from '@/views/homehadle/Home.vue';

export const routers = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login/index.vue"),
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: () => import("../views/Login/maintenance.vue"),
    // meta: {
    //   isNormal: true,
    //   title: "maintenance",
    //   TabbarShow: false //系统维护中
    // }
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import("../views/Layout.vue"),
    // redirect: { name: "Home" },
    children: [
      // {
      //   path: '/home',
      //   name: 'Home',
      //   component: Home,
      //   meta: {
      //     isPortal: true,
      //     TabbarShow: true //需要显示底部导航
      //   }
      // },
      // {
      //   path: '/maintenance',
      //   name: 'maintenance',
      //   component: () => import("../views/pages/maintenance.vue"),
      //   meta: {
      //     TabbarShow: false //系统维护中
      //   }
      // },
      // {
      //   path: '/home/more',
      //   name: 'recommendFor',
      //   component: () => import('../views/homehadle/recommendFor.vue'),
      //   meta: {
      //     TabbarShow: true //需要显示底部导航
      //   }
      // },
      // {
      //   path: '/about',
      //   name: 'About',
      //   component: () => import('../views/abouthandle/About.vue'),
      //   meta: {
      //     TabbarShow: true //需要显示底部导航
      //   }
      // },
      // {
      //   path: "/reportList/:parentId/:label?",
      //   name: "reportList",
      //   meta: {
      //     title: "reports",
      //     goBack: "Report",
      //     TabbarShow: false,
      //   },
      //   component: () => import("../views/Report/reportGroup.vue")
      // },
      // {
      //   path: "/reportView/:reportId/:parendId?",
      //   name: "reportView",
      //   meta: {
      //     title: "reportDetails",
      //     goBack: "Report",
      //     TabbarShow: false
      //   },
      //   component: () => import("../views/Report/reportView.vue")
      // },
      // {
      //   path: "/search/:type?",
      //   name: "searchsView",
      //   component: () => import("../components/searchsView.vue"),
      //   meta: {
      //     title: "report-home",
      //     TabbarShow: false
      //   }
      // },
      // {
      //   path: "/checkData/:reportId/:sheetId/:taskName/:type",
      //   name: "checkData",
      //   component: () => import("../views/Task/checkData.vue"),
      // },
      // {
      //   path: "/doneCheckData/:reportId/:sheetId/:taskName/:type",
      //   name: "doneCheckData",
      //   component: () => import("../views/Task/checkData.vue"),
      // },
      // {
      //   path: "/checkData/:reportId/:sheetId/:taskName/:type",
      //   name: "checkData",
      //   component: () => import("../views/Task/checkData.vue"),
      // },
      // {
      //   path: "/sheetSelect/:taskId/:jobID/:taskName?/:type?",
      //   name: "sheetSelect",
      //   component: () => import("../views/Task/sheetSelect.vue"),
      // },
      // {
      //   path: "/checkForm/:taskId/:jobID/:taskName?/:type?",
      //   name: "checkForm",
      //   component: () => import("../views/Task/checkForm.vue"),
      // },
      // {
      //   path: "/checkProcess",
      //   name: "checkProcess",
      //   component: () => import("../views/Task/checkProcess.vue"),
      // },
      // {
      //   path: "/tabar/:collection", //首页下的收藏
      //   name: "collection",
      //   component: () => import("../views/homehadle/collection.vue"),
      //   meta: {
      //     TabbarShow: true //需要显示底部导航
      //   }
      // },
      // {
      //   path: "/tabar/:types?", //最近浏览
      //   name: "tabsView",
      //   component: () => import("../views/abouthandle/tabsView.vue"),
      //   meta: {
      //     TabbarShow: true
      //   }
      // },
      // {
      //   path: "/collection/:label",
      //   name: "reportCollent",
      //   meta: {
      //     title: "reportCollent",
      //     goBack: "reportCollent",
      //     TabbarShow: false,
      //   },
      //   component: () => import("../views/homehadle/collection.vue")
      // },
      // {
      //   path: "/homeEditor", //首页下的编辑
      //   name: "homeEditor",
      //   component: () => import("../views/homehadle/homeEditor.vue"),
      // },
      // {
      //   path: "/tabar/message", //我的消息
      //   name: "myMessage",
      //   component: () => import("../views/abouthandle/myMessage.vue"),
      //   meta: {
      //     TabbarShow: true
      //   }
      // },
      // {
      //   path: "/myMessage/:msgid?",
      //   name: "myMessageDeatil",
      //   component: () => import("../views/abouthandle/myMessageDeatil.vue"),
      //   meta: {
      //     TabbarShow: false
      //   }
      // },
      // {
      //   path: "/personInfo", //我的个人信息
      //   name: "personInfo",
      //   component: () => import("../views/abouthandle/personInfo.vue"),
      //   meta: {
      //     TabbarShow: false
      //   },
      // },
      // {
      //   path: "/editInfo/:type", //编辑个人信息
      //   name: "editPersonInfo",
      //   component: () => import("../views/abouthandle/editPersonInfo.vue"),
      //   meta: {
      //     TabbarShow: false
      //   },
      // },
      // {
      //   path: "/404",
      //   name: "404",
      //   component: () => import("../views/404page.vue"),
      // },
      // {
      //   path: "/editInfo/:type", //编辑个人信息
      //   name: "setsPerson",
      //   component: () => import("../views/abouthandle/setsPerson.vue"),
      //   meta: {
      //     TabbarShow: false
      //   },
      // },
    ]
  }
];